var React = require('react');

function StreamlineFilled27Remove1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.414 12.002L23.708 1.707c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0L12 10.588 1.706.294C1.315-.097.683-.097.292.294-.1.686-.1 1.318.291 1.709l10.294 10.293L.294 22.294c-.391.391-.391 1.024 0 1.414.392.392 1.024.392 1.415.001L12 13.416l10.293 10.292c.391.391 1.023.391 1.414 0s.391-1.023 0-1.414L13.414 12.002z","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineFilled27Remove1.displayName = "StreamlineFilled27Remove1";

StreamlineFilled27Remove1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineFilled27Remove1;

StreamlineFilled27Remove1.default = StreamlineFilled27Remove1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-filled-27-remove-1.svg
// module id = 764
// module chunks = 0